/**
 * Created by tayloremolo on 11/4/17.
 */
import React, {Component} from 'react';
import ReactDOM from "react-dom";

class IframeVideo extends Component {
    // constructor() {
    //     super();
    //
    // }
    // componentDidMount(){
    //     });
    // }

    render() {

        return (
            <div>
                {/*<iframe className="z-depth-5" src="https://player.vimeo.com/video/240791567" width={640} height={360} frameBorder={0} allowFullScreen />*/}
                <div className="wistia_responsive_padding" style={{padding: '56.0% 0 0 0', position: 'relative'}}>
                    <div className="wistia_responsive_wrapper" style={{height: '100%', left: 0, position: 'absolute', top: 0, width: '100%'}}>
                        <iframe src="//fast.wistia.net/embed/iframe/9awnwimgrk?videoFoam=true" allowTransparency="true" frameBorder={0} scrolling="no" className="wistia_embed" name="wistia_embed" allowFullScreen mozallowfullscreen webkitallowfullscreen oallowfullscreen msallowfullscreen style={{height: '100%', width:'100%'}} />
                    </div>
                </div>
            </div>
        )

    }

}

export default IframeVideo;


// WEBPACK FOOTER //
// ./src/components/iframe-video.js